import { InvoicesProvider } from './contexts/InvoicesContext';
import { InvoicePopups } from './components/InvoicePopups';
import { InvoiceBox } from './components/InvoiceSearchBox';
import PageArea from '../../components/shared/PageArea';
import PageTitle from '../../components/shared/PageTitle';
import { useTranslation } from 'react-i18next';

const Invoices = () => {
  const { t } = useTranslation('invoices');

  return (
    <InvoicesProvider>
      <PageArea>
        <PageTitle subTitle='Manage your Invoices'>{t('title')}</PageTitle>
        <InvoiceBox></InvoiceBox>
        <InvoicePopups></InvoicePopups>
      </PageArea>
    </InvoicesProvider>

  );
};

export default Invoices;
